const Logo = () => (
  <svg
    width="71"
    height="90"
    viewBox="0 0 71 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0"
      fillRule="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="71"
      height="90"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H71V90H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.5036 37.2213C59.4825 37.9304 59.3667 38.9887 59.3351 39.2004L59.2719 39.7507C58.9772 42.6188 58.1981 45.2117 56.9453 47.54C55.5872 50.0694 53.8606 52.2389 51.7656 54.0381C49.6705 55.8796 47.2386 57.3189 44.4698 58.3455C41.6904 59.372 38.7952 59.8906 35.7632 59.8906C32.4259 59.8906 29.2991 59.2557 26.3513 57.9645C23.4035 56.6839 20.8241 54.9271 18.6028 52.694C16.3498 50.4292 14.5916 47.8575 13.3599 44.9788C12.086 42.0155 11.4438 38.8617 11.4438 35.5174C11.4438 32.2154 12.0755 29.0405 13.3599 25.9925C14.0021 24.4896 14.7601 23.1032 15.6339 21.8121C16.5077 20.5315 17.5078 19.3251 18.6133 18.2138C20.8768 16.0336 23.4561 14.298 26.3618 13.0068C29.3096 11.7262 32.4469 11.0807 35.7737 11.0807C40.0375 11.0807 43.9223 12.0755 47.4176 14.044C48.8704 14.8377 50.1969 15.7585 51.4076 16.785L51.4813 16.8486C53.2711 18.6371 53.2395 21.5687 51.3866 23.3149C49.6179 24.9764 46.828 24.8601 45.112 23.135L45.1014 23.1244C45.0909 23.1032 45.0699 23.0927 45.0488 23.0715C44.8593 22.9127 43.6907 21.992 42.9537 21.5581C40.6902 20.1823 38.3004 19.4944 35.7842 19.4944C33.7419 19.4944 31.7521 19.9283 29.836 20.7855C27.8778 21.7274 26.2565 22.9022 24.9721 24.3203C23.6035 25.7808 22.4981 27.4741 21.6453 29.4003C20.8241 31.3264 20.4241 33.3584 20.4241 35.5068C20.4241 37.687 20.8347 39.7295 21.6453 41.6133C22.4981 43.5395 23.6035 45.2328 24.9721 46.6933C26.2986 48.1538 27.9199 49.3074 29.836 50.1646C31.6678 51.0642 33.6471 51.5193 35.7842 51.5193C37.4055 51.5193 38.9637 51.2653 40.4586 50.7467C41.9536 50.2704 43.3117 49.5826 44.554 48.683C45.7436 47.8258 46.8385 46.7568 47.8176 45.4656C48.3756 44.7354 48.8072 43.984 49.102 43.2114C49.3547 42.6928 49.3442 42.2484 49.0704 41.8885C48.7862 41.5181 48.3756 41.3382 47.8176 41.3382H43.4591C41.2272 41.3382 39.4269 39.5285 39.4269 37.2848C39.4269 35.0412 41.2272 33.2314 43.4591 33.2314H55.8293C57.8612 33.1997 59.5246 34.8507 59.5036 36.925V37.2213ZM35.5526 0H35.4579C15.8655 0 0 15.9596 0 35.6338C0 41.2641 1.29494 46.5875 3.61107 51.3182C3.61107 51.3182 7.21161 61.1183 35.2579 89.8942C35.321 89.9576 35.4053 90 35.5 90C35.5842 90 35.679 89.9576 35.7421 89.8942C63.7779 61.1183 67.3889 51.3182 67.3889 51.3182C69.7051 46.5875 71 41.2641 71 35.6338C71 15.949 55.124 0 35.5526 0Z"
        fill="white"
      />
    </g>
  </svg>
);

export default Logo;
